const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { Base64 } = require('js-base64');
const apiConfig = require('../../api-config');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  const reqOpts = { headers, method: 'POST' };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getStatus(inputParam, metaData) {
      const url = getUrl('sepa-ip-payment/status');
      const reqOpts = {headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = JSON.parse(Base64.decode(inputParam));
      const body = {
        userId: parsedMetaData.qs.userId,
        deviceCode: params.deviceCode,
        channel: params.channel,
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language,
        txToken: params.txToken
      };
      
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },


  };
}

module.exports = apiFactory;